module.exports = __webpack_public_path__ + "img/image_4.4c1a520e.jpg";